var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-table-show-off",on:{"click":_vm.showOff}},[(_vm.isLoading)?_c('div',[_c('spinner',{staticClass:"small"})],1):_c('div',[_c('svg-loader',{staticClass:"data-table-show-off-caret",style:({
        transform: _vm.isOpen ? 'rotate(180deg)' : undefined
      }),attrs:{"src":"/static/images/icon-caret.svg"}})],1)])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }